import type { MatterDraft, TranscriptRow } from "./ui-types";

const today = new Date().toISOString().slice(0, 10);

export const DEMO_MATTER: MatterDraft = {
  title: "Harbour Ridge Holdings — examination of Elena Ruiz",
  reference: "HRH-2026-014",
  proceeding: "Deposition / Examination",
  jurisdictionPack: "AU-NSW",
  venue: "Level 18, 60 Martin Place, Sydney",
  date: today,
  timezone: "Australia/Sydney",
  languages: ["English"],
  participants: [
    { name: "Alexander Hale", role: "Examining solicitor" },
    { name: "Elena Ruiz", role: "Witness" },
    { name: "Mei Tan", role: "Solicitor for witness" }
  ],
  glossary: [
    "Harbour Ridge Holdings",
    "Elena Ruiz",
    "Project Banksia",
    "DHR-14",
    "Newcastle facility"
  ],
  authorityReference: "Client authority and participant notice recorded 29 July 2026",
  authority: {
    userAttestation: true,
    participantNotice: true,
    participantConsent: true,
    confidentialityReviewed: true,
    courtApproval: false
  }
};

export const DEMO_TRANSCRIPT: TranscriptRow[] = [
  {
    id: "n-001",
    line: 1,
    startMs: 1240,
    endMs: 4670,
    speakerId: "spk-01",
    speaker: "Alexander Hale",
    role: "Q",
    baseline: "Could you state your full name for the record?",
    text: "Could you state your full name for the record?",
    wordConfidence: 98,
    speakerConfidence: 97,
    alignmentConfidence: 99,
    reviewScore: 98,
    reasons: []
  },
  {
    id: "n-002",
    line: 2,
    startMs: 5210,
    endMs: 7380,
    speakerId: "spk-02",
    speaker: "Elena Ruiz",
    role: "A",
    baseline: "Elena Maria Ruiz.",
    text: "Elena Maria Ruiz.",
    wordConfidence: 99,
    speakerConfidence: 98,
    alignmentConfidence: 99,
    reviewScore: 99,
    reasons: ["name"]
  },
  {
    id: "n-003",
    line: 3,
    startMs: 8020,
    endMs: 13360,
    speakerId: "spk-01",
    speaker: "Alexander Hale",
    role: "Q",
    baseline: "You were the finance director of Harbour Ridge Holdings in May 2025?",
    text: "You were the finance director of Harbour Ridge Holdings in May 2025?",
    wordConfidence: 95,
    speakerConfidence: 97,
    alignmentConfidence: 96,
    reviewScore: 95,
    reasons: ["name", "date"]
  },
  {
    id: "n-004",
    line: 4,
    startMs: 13920,
    endMs: 15110,
    speakerId: "spk-02",
    speaker: "Elena Ruiz",
    role: "A",
    baseline: "That is correct.",
    text: "That is correct.",
    wordConfidence: 99,
    speakerConfidence: 98,
    alignmentConfidence: 99,
    reviewScore: 99,
    reasons: []
  },
  {
    id: "n-005",
    line: 5,
    startMs: 16820,
    endMs: 23940,
    speakerId: "spk-01",
    speaker: "Alexander Hale",
    role: "Q",
    baseline: "Please turn to exhibit DHR-14, the email sent at 4:18 pm on 9 May.",
    text: "Please turn to exhibit DHR-14, the email sent at 4:18 pm on 9 May.",
    wordConfidence: 89,
    speakerConfidence: 96,
    alignmentConfidence: 92,
    reviewScore: 88,
    reasons: ["number", "date"],
    flaggedText: "DHR-14"
  },
  {
    id: "n-006",
    line: 6,
    startMs: 24710,
    endMs: 25780,
    speakerId: "spk-02",
    speaker: "Elena Ruiz",
    role: "A",
    baseline: "I have it.",
    text: "I have it.",
    wordConfidence: 99,
    speakerConfidence: 98,
    alignmentConfidence: 99,
    reviewScore: 99,
    reasons: []
  },
  {
    id: "n-007",
    line: 7,
    startMs: 26680,
    endMs: 33190,
    speakerId: "spk-01",
    speaker: "Alexander Hale",
    role: "Q",
    baseline: "The subject line reads Project Bank see a—revised drawdown. Is that right?",
    text: "The subject line reads Project Bank see a—revised drawdown. Is that right?",
    wordConfidence: 54,
    speakerConfidence: 95,
    alignmentConfidence: 61,
    reviewScore: 48,
    reasons: ["low-confidence", "provider-disagreement", "name"],
    flaggedText: "Bank see a"
  },
  {
    id: "n-008",
    line: 8,
    startMs: 33740,
    endMs: 39350,
    speakerId: "spk-02",
    speaker: "Elena Ruiz",
    role: "A",
    baseline: "Yes, although I understood Banksia to refer to the Newcastle facility.",
    text: "Yes, although I understood Banksia to refer to the Newcastle facility.",
    wordConfidence: 82,
    speakerConfidence: 74,
    alignmentConfidence: 88,
    reviewScore: 72,
    reasons: ["uncertain-speaker", "name"],
    flaggedText: "Banksia"
  },
  {
    id: "n-009",
    line: 9,
    startMs: 39920,
    endMs: 42320,
    speakerId: "spk-03",
    speaker: "Mei Tan",
    role: "MS TAN",
    baseline: "I object to the characterisation.",
    text: "I object to the characterisation.",
    wordConfidence: 94,
    speakerConfidence: 63,
    alignmentConfidence: 92,
    reviewScore: 68,
    reasons: ["uncertain-speaker", "overlap"]
  },
  {
    id: "n-010",
    line: 10,
    startMs: 42120,
    endMs: 44700,
    speakerId: "spk-01",
    speaker: "Alexander Hale",
    role: "MR HALE",
    baseline: "The objection is noted.",
    text: "The objection is noted.",
    wordConfidence: 91,
    speakerConfidence: 69,
    alignmentConfidence: 75,
    reviewScore: 66,
    reasons: ["uncertain-speaker", "overlap"]
  }
];

export const DEMO_VERSION_ID = "DCT-HRH-014-V1";
export const DEMO_HASH =
  "a85d1efbd395179bb210959502b4203ec8ff9a819b91be4f763089c2026473c2";
